import { createFileRoute } from "@tanstack/react-router";
import { CallFlowMapScreen } from "../components/relations/CallFlowMapScreen";

export const Route = createFileRoute("/_auth/relations/flow")({
  staticData: {
    titleKey: "relations.flow.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 7,
  },
  component: CallFlowMapScreen,
});
